// extracted by mini-css-extract-plugin
export default {"makeWords":"MakeWords_makeWords__LLc8D","oneWord":"MakeWords_oneWord__9Jdfd","counter":"MakeWords_counter__p-pzN"};